// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xPrn","left":"styles_left__11_xv"};